// Basic AWS region validation to prevent invalid/unsafe region values.
// See: https://github.com/advisories/GHSA-j965-2qgj-vjmq
const AWS_REGION_RE = /^[a-z]{2}(-gov)?-[a-z0-9-]+-\d+$/;

export function assertValidAwsRegion(region: string): string {
  if (!region || !AWS_REGION_RE.test(region)) {
    throw new Error(`Invalid AWS region: ${region}`);
  }
  return region;
}
